/**
 * Enum representing the possible client decisions for inspections
 */
enum ClientDecision {
    FAIL_RTV_CANCEL = 'Fail - RTV - Cancelled',
    FAIL_RTV100 = 'Fail - RTV for 100% process',
    PASS_LEVEL1 = 'Pass - after level 1 check',
    PASS_LEVEL2 = 'Pass - after level 2 check',
    PASS_CPR_LEVEL1 = 'Pass - with CPR after level 1 check',
    PASS_CPR_LEVEL2 = 'Pass - with CPR after level 2 check',
    UNDER_REVIEW = 'Under Review'
} export default ClientDecision;

